/**
 * Theme palette configuration for Adigon.
 * This defines the color scheme used throughout the application.
 */
const lightPalette = {
  mode: 'light',
  primary: {
    main:  '#0d6efd',
  },
  secondary: {
    main:  '#6c757d',
  },
  background: {
    default: '#ffffff',
    paper:   '#ffffff',
    alt:    '#f5f5f5',
  },
  text: {
    primary:   '#212529',
    secondary: '#495057',
  },
  divider: '#dee2e6',
  error: {
    main:  '#dc3545',
  },
  warning: {
    main:  '#ffc107',
  },
  info: {
    main:  '#0dcaf0',
  },
  success: {
    main:  '#198754',
  },
  noImg:{
    main: '#9d9ea0ff',
  },
};

const darkPalette = {
  mode: 'dark',
  primary: {
    main:  '#90d5ff',
  },
  secondary: {
    main:  '#6c757d',
  },
  background: {
    default: '#212529',
    paper:   '#343a40',
    alt:     '#414447',
  },
  text: {
    primary:   '#f8f9fa',
    secondary: '#ced4da',
  },
  divider: '#787e86ff',
  error: {
    main:  '#dc3545',
  },
  warning: {
    main:  '#ffc107',
  },
  info: {
    main:  '#0dcaf0',
  },
  success: {
    main:  '#4ade80',
  },
  noImg:{
    main: '#9d9ea0ff',
  },
};

export { lightPalette, darkPalette };